import { render, staticRenderFns } from "./ManageMizodiaOrders.vue?vue&type=template&id=6b077875&scoped=true&"
import script from "./ManageMizodiaOrders.vue?vue&type=script&lang=js&"
export * from "./ManageMizodiaOrders.vue?vue&type=script&lang=js&"
import style0 from "./ManageMizodiaOrders.vue?vue&type=style&index=0&id=6b077875&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b077875",
  null
  
)

export default component.exports